import { render, staticRenderFns } from "./chat-message-box.vue?vue&type=template&id=43df305f&scoped=true&"
import script from "./chat-message-box.vue?vue&type=script&lang=js&"
export * from "./chat-message-box.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-box.vue?vue&type=style&index=0&lang=less&"
import style1 from "./chat-message-box.vue?vue&type=style&index=1&id=43df305f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43df305f",
  null
  
)

export default component.exports